import useStore from "../../../store"
import { useNavigate } from "react-router-dom"
import { FaTrailer } from "react-icons/fa"
import HighlightMatch from "../../../utilities/HighlightMatch"
import vciDealerStatus from "../../../utilities/vciDealerStatus"
import AuditButton from "./AuditButton"
import TrailerAuditButton from "./TrailerAuditButton"
import TrailerLocationDealerName from "./TrailerLocationDealerName"
import VCIDealerRowDetails from "./VCIDealerRowDetails"
import { AUDIT_SOURCE } from "../../../utilities/auditDealerAdapters"


export default function VCIDealerRow({ dealer, searchTerm }) {
  const navigate = useNavigate()
  const status = vciDealerStatus(dealer)

  const dealerInState = useStore((state) => state.dealer)
  const breadcrumbTrail = useStore((state) => state.breadcrumbTrail)
  const setBreadcrumbTrail = useStore((state) => state.setBreadcrumbTrail)

  const isTrailer = dealer.source === AUDIT_SOURCE.TRAILER

  const handleRowClick = () => {
    if (isTrailer) {
      const path = `/locations/${dealer.id}`
      setBreadcrumbTrail([
        ...breadcrumbTrail,
        { label: dealer.attributes.name, path },
      ])
      navigate(path)
      return
    }
    if (dealerInState?.id !== dealer.id) {
      useStore.setState({ dealer: null })
    }
    navigate(`/dealers/${dealer.id}`)
  }

  return (
    <div
      className="flex w-full items-center border-b-2 border-grey-700
        p-2 text-grey-300 text-left lg:hover:bg-grey-700 hover:cursor-pointer"
    >
      <div
        className="flex flex-col w-1/2 md:w-2/3 hover:cursor-pointer"
        onClick={handleRowClick}
      >
        <VCIDealerRowDetails dealer={dealer} searchTerm={searchTerm} />

        <div className="flex items-center gap-2 font-bold text-lg text-grey-100">
          {isTrailer && <FaTrailer className="shrink-0" title="Trailer location" />}
          <HighlightMatch
            str={dealer.attributes.name}
            match={searchTerm}
            truncate={true}
          />
        </div>

        {isTrailer && <TrailerLocationDealerName location={dealer} searchTerm={searchTerm} />}

        <div className={`${status.style} text-xs`}>
          {status.text}
        </div>
      </div>

      <div className="flex flex-col justify-end w-1/2 md:w-1/3">
        {isTrailer
          ? <TrailerAuditButton location={dealer} />
          : <AuditButton dealer={dealer} />
        }
      </div>
    </div>
  )
}